module.exports = __webpack_public_path__ + "static/media/zip.92c70c66.svg";